import CoreSplitCallToAction from './CoreSplitCallToAction';

export { type CoreSplitCallToActionProps } from './CoreSplitCallToAction';
export default CoreSplitCallToAction;
